<template>
  <div>
    <div class="tw:pt-4 tw:px-4">
      <BillingHeader title="tbs_product_overview" />
      <InvoicesFilters :accommodationsData="accommodationsData" />
      <EmptyState
        v-if="!isInvoicesListLoading && invoicesList.length === 0"
        title="no_results"
        text="rc_booking_details_no_data_info"
        class="tw:mb-6"
      />
    </div>

    <InvoicesList
      :accommodationsData="accommodationsData"
      :invoices="invoicesList"
      :isLoading="isInvoicesListLoading"
      :hasEmptyTable="hasEmptyTable"
    />
  </div>
</template>
<script setup>
import { computed, watch } from 'vue'

import BillingHeader from '@/components/billing/BillingHeader.vue'
import InvoicesFilters from '@/components/billing/invoices/InvoicesFilters.vue'
import InvoicesList from '@/components/billing/invoices/InvoicesList.vue'
import EmptyState from '@/components/billing/EmptyState.vue'

import { useAccommodationsByOrgId } from '@/layouts/queries'
import { useInvoicesFilters } from '@/components/billing/invoices/useInvoicesFilters'
import { useInvoices } from './query'
import { storage } from '@/utils/storageService'
import { useSessionValues } from '@/composables/useSessionValues'

const { selectedPropertyValues, selectedProductValues, selectedStatusValues, startDate, endDate } = useInvoicesFilters()

const { selectedOrganisationId } = useSessionValues()
const { accommodationsData } = useAccommodationsByOrgId(selectedOrganisationId)
const propertyFilterValues = computed(() =>
  selectedPropertyValues.value.length === 1 && selectedPropertyValues.value[0].value === 'all'
    ? ''
    : selectedPropertyValues.value.map(item => item.value).join(',')
)
const statusesFilterValues = computed(() => {
  return selectedStatusValues.value.length === 1 && selectedStatusValues.value[0].value === 'all'
    ? ''
    : selectedStatusValues.value.map(item => item.value).join(',')
})
const productsFilterValues = computed(() => {
  return selectedProductValues.value.length === 1 && selectedProductValues.value[0].value === 'all'
    ? ''
    : selectedProductValues.value.map(item => item.value).join(',')
})

const { invoicesList, isInvoicesListLoading } = useInvoices({
  accommodationIds: propertyFilterValues,
  productTypes: productsFilterValues,
  paymentStatuses: statusesFilterValues,
  startDate: startDate,
  endDate: endDate,
})

const hasEmptyTable = computed(() => invoicesList.value?.length === 0)

watch(
  invoicesList,
  newData => {
    if (newData) {
      const proSub = newData.some(item => item?.productType !== 'PLUS' && item?.productType !== 'RATE_CONNECT')
      if (productsFilterValues.value.includes('PRO')) {
        storage.setItem('hasProSubscription', true)
      } else {
        storage.setItem('hasProSubscription', proSub)
      }
    }
  },
  { once: true }
)
</script>
